module.exports = __webpack_public_path__ + "img/landing.cfb7dec1.webp";